module.exports = __webpack_public_path__ + "img/meeting_url_hint.54b53420.png";